import React from "react";

import NavBar from "../../components/navbar/navbar.component";
import Header from "../../components/header/header.component";
import Course from "../../components/course/course.component";
import COURSES_DATA from './courses.data';
import './courses.styles.scss';

const CoursesPage = () => (
  <div>
    <NavBar height={window.innerHeight * 0.4} />
    <Header />

    <div className='section'>
      <p className='title center'>Courses</p>
      <hr />
      <div>
        {COURSES_DATA.courses.map(({ id, ...coursesProps }) => 
          <Course key={id} { ...coursesProps } />
        )}
      </div>
    </div>
  </div>
);

export default CoursesPage;
